import Vue from "vue";
import Vuex from "vuex";

import admin from "./modules/admin";
import adminUserPost from "./modules/adminUserPost";
import api from "./modules/api";
import session from "./modules/session";

Vue.use(Vuex);

export default new Vuex.Store({
  getters: {
    baseUrl() {
      return `${location.protocol}//${location.host}/api/v1/`;
    }
  },

  state: {},
  mutations: {},
  actions: {},
  modules: {
    admin,
    adminUserPost,
    api,
    session
  }
});
